import { lazy } from "react";
import { Navigate, Outlet, Route } from "react-router-dom";
import MainLayout from "./layouts/main-layout";
import PrivateRoute from "./private-route";

const Dashboard = lazy(() => import("../modules/Inventory/Dashboard"));
const Shipments = lazy(() => import("../modules/Inventory/Shipment"));
const AddItemsToInventory = lazy(
  () => import("../modules/Inventory/Shipment/AddItemsToInventory"),
);
const Orders = lazy(() => import("../modules/Inventory/Orders"));
const Reports = lazy(() => import("../modules/Inventory/Reports"));
const Settings = lazy(() => import("../modules/Inventory/Settings"));
const SettingsProfile = lazy(
  () => import("../modules/Inventory/Settings/Profile"),
);
const Audits = lazy(() => import("../modules/Inventory/Settings/Audits"));
const AllInventory = lazy(() => import("../modules/Inventory/Inventory"));
const AdjustLevels = lazy(
  () => import("../modules/Inventory/Inventory/AdjustLevels"),
);
const TransferInventory = lazy(
  () => import("../modules/Inventory/TransferInventory"),
);
const CartScreen = lazy(() => import("../modules/Inventory/Cart"));
const ShipmentInvoiceDetail = lazy(
  () => import("../modules/Inventory/Shipment/Details/ShipmentInvoiceDetail"),
);
const InventoryMedication = lazy(
  () => import("../modules/Inventory/Formulary"),
);
const AddInventoryMedication = lazy(
  () => import("../modules/Inventory/Formulary/AddMedication"),
);

const MainRoute = () => (
  <PrivateRoute>
    <MainLayout>
      <Outlet />
    </MainLayout>
  </PrivateRoute>
);

const InventoryRoutes = (
  <Route path="/inventory" element={<MainRoute />}>
    <Route index element={<AllInventory />} />
    <Route path="dashboard" element={<Dashboard />} />
    <Route path="formulary" element={<InventoryMedication />} />
    <Route path="add-medications" element={<AddInventoryMedication />} />
    <Route path="shipments" element={<Shipments />} />
    <Route path="inventory" element={<AllInventory />} />
    <Route path="inventory/adjust-levels" element={<AdjustLevels />} />
    <Route path="inventory/transfer" element={<TransferInventory />} />
    <Route path="orders" element={<Orders />} />
    <Route path="reports" element={<Reports />} />
    <Route path="cart" element={<CartScreen />} />
    <Route path="settings" element={<Settings />}>
      <Route index element={<Navigate to="audits" replace />} />
      <Route path="profile" element={<SettingsProfile />} />
      <Route path="audits" element={<Audits />} />
    </Route>
    <Route path="shipments/:invoiceId" element={<ShipmentInvoiceDetail />} />
    <Route
      path="shipments/:invoiceId/add-items"
      element={<AddItemsToInventory />}
    />
  </Route>
);

export default InventoryRoutes;
